<template>
  <div class="outbox">
    <topNav class="isNav"></topNav>
    <!-- 导航栏 -->
    <div class="inNav">
      <div class="nav isNav" :class="checked == 1 ? 'nav_01' : ''">
        <div class="navCliAbout">关于德讯</div>
        <div
          class="navCli"
          :id="checked == 1 ? 'isme' : ''"
          @click="checkedThis(1)"
        >
          公司简介
        </div>
        <div
          class="navCli"
          :id="checked == 2 ? 'isme' : ''"
          @click="checkedThis(2)"
        >
          企业文化
        </div>
        <div
          class="navCli"
          :id="checked == 3 ? 'isme' : ''"
          @click="checkedThis(3)"
        >
          公司资质
        </div>
        <!-- <div
          class="navCli"
          :id="checked == 4 ? 'isme' : ''"
          @click="checkedThis(4)"
        >
          党建专栏
        </div> -->
        <div
          class="navCli"
          :id="checked == 5 ? 'isme' : ''"
          @click="checkedThis(5)"
        >
          公司动态
        </div>
        <div
          class="navCli"
          :id="checked == 11 ? 'isme' : ''"
          @click="checkedThis(11)"
        >
          德财院
        </div>
        <div
          class="navCli"
          :id="checked == 6 ? 'isme' : ''"
          @click="checkedThis(6)"
        >
          人员公示
        </div>
        <div
          class="navCli"
          :id="checked == 7 ? 'isme' : ''"
          @click="checkedThis(7)"
        >
          支付公示
        </div>
        <div
          class="navCli"
          :id="checked == 8 ? 'isme' : ''"
          @click="checkedThis(8)"
        >
          诚聘英才
        </div>
        <div
          class="navCli"
          :id="checked == 9 ? 'isme' : ''"
          @click="checkedThis(9)"
        >
          联系我们
        </div>
        <div
          class="navCli"
          :id="checked == 10 ? 'isme' : ''"
          @click="checkedThis(10)"
        >
          相关声明
        </div>
        <div class="navBom"></div>
      </div>
    </div>
    <div class="top">
      <el-carousel trigger="click" class="bannerMain" v-show="banners.length>1">
        <el-carousel-item v-for="(item,index) in banners" :key="index">
          <div class="bannerimg">
            <img :src="item" class="bannerimg" alt="" />
            <!-- <a v-if="index == 0" href="https://www.dexunzhenggu.cn/h5/html/showimg.html?id=1" target="_blank"></a> -->
            <!-- <img :src="item.imgSrc" class="bannerimg" alt="" />
            <a v-if="item.to" :href="item.url" target="_blank"></a> -->
          </div>
        </el-carousel-item>
      </el-carousel>
      <img :src="banners[0]" v-show="banners.length<=1" class="bannerimg" alt="" />
    </div>
    <div class="box">
      <!-- 内容 -->
      <div class="content">
        <A01_gsjj id="A01_gsjj" v-if="checked == 1"></A01_gsjj>
        <A02_qywh id="A02_qywh" v-if="checked == 2"></A02_qywh>
        <A03_gszz id="A03_gszz" v-if="checked == 3"></A03_gszz>
        <A04_djzl id="A04_djzl" v-if="checked == 4"></A04_djzl>
        <A05_gsdt id="A05_gsdt" v-if="checked == 5"></A05_gsdt>
        <A06_rygs id="A06_rygs" v-if="checked == 6"></A06_rygs>
        <A07_zfgs id="A07_zfgs" v-if="checked == 7"></A07_zfgs>
        <A08_cpyc id="A08_cpyc" v-if="checked == 8"></A08_cpyc>
        <A09_lxwm id="A09_lxwm" v-if="checked == 9"></A09_lxwm>
        <A10_xgsm id="A10_xgsm" v-if="checked == 10"></A10_xgsm>
        <C01_dcjyxt id="C01_dcjyxt" v-if="checked == 11"></C01_dcjyxt>
      </div>
    </div>
    <Bottoms></Bottoms>
  </div>
</template>
<script>
import topNav from "./sub/topNav";
import Bottoms from "./sub/Bottoms";
import A01_gsjj from "./aboutS/A01_gsjj";
import A02_qywh from "./aboutS/A02_qywh";
import A03_gszz from "./aboutS/A03_gszz";
import A05_gsdt from "./aboutS/A05_gsdt";
import A06_rygs from "./aboutS/A06_rygs";
import A04_djzl from "./aboutS/A04_djzl";
import A07_zfgs from "./aboutS/A07_zfgs";
import A08_cpyc from "./aboutS/A08_cpyc";
import A09_lxwm from "./aboutS/A09_lxwm";
import A10_xgsm from "./aboutS/A10_xgsm";
import C01_dcjyxt from "./aboutS/C01_dcjyxt";
import { colunmList,productList,columnTypeList } from "@/api/topNav.js";
import { l } from "@/utils/tool";
export default {
  name: "about",
  components: {
    topNav,
    Bottoms,
    A01_gsjj,
    A02_qywh,
    A03_gszz,
    A04_djzl,
    A05_gsdt,
    A06_rygs,
    A07_zfgs,
    A08_cpyc,
    A09_lxwm,
    A10_xgsm,
    C01_dcjyxt,
  },
  data() {
    return {
      checked: 1,
      banners:[],
    };
  },
  mounted() {
    // this.getlist();
    window.scrollTo(0, 0);
    this.selectf();
    var num = this.$route.query.index;
    if (num == undefined || num == null) {
      this.checked = 1;
    } else {
      this.checked = Number(num);
    }
  },
  methods: {
    checkedThis: function (item) {
      //console.log(item);
      this.$router.push({ path: "/about?index=" + item });
      this.checked = item;
    },
    selectf(){
        colunmList({ column_name:'关于德讯' }).then((res) => { //产品管理列表
        //列表
        if (res.code == 200 && res.data.list) {
          // l(res,'ds');
          this.banners = res.data.list[0].pictures.split(',');
        }
      });
    }
  },
  watch: {
    $route: {
      handler(t, f) {
        // console.log(t.fullPath);
        var to = t.fullPath;
        var r = localStorage.getItem("aboutR");

        if (to != r) {
          localStorage.setItem("aboutR", to);
          // window.scrollTo(0, 400);
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped>
.bannerMain >>> .el-carousel__container {
  width: 100%;
  height: 400px !important;
}
.bannerimg {
  display: block;
  width: 100%;
  max-width: 1920px;
  height: 400px;
  margin: auto;
  position: relative;
}
.outbox {
  width: 100%;
  position: relative;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
.top {
  width: 100%;
  height: 400px;
  /* background: url("../common/images/about/top.png") no-repeat; */
  background-size: 100% 100%;
}
.box {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  margin: 20px auto 0;
  margin-bottom: 80px;
  /* height: 1500px;
  background-color: pink; */
}
.content {
  width: 1400px;
  margin: 0 auto;
  margin-top: 20px;
  /* min-height: 1540px; */
}
/* 导航栏 */
.inNav {
  width: 176px;
  height: 1620px;
  position: absolute;
  top: 420px;
  left: 50%;
  margin-left: -700px;
}
.nav {
  width: 176px;
  height: 1010px;
  background-color: #e4e4e4;
  opacity: 1;
  z-index: 50;
}
.nav_01 {
  position: sticky;
  top: 110px;
}
#isme {
  color: #e7413b;
}
.navCliAbout {
  position: relative;
  width: 176px;
  height: 80px;
  background: url("../common/images/about/navCliAbout.png") no-repeat;
  background-size: 100% 100%;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 80px;
  color: #ffffff;
  opacity: 1;
}
.navCliAbout::before {
  position: absolute;
  top: 80px;
  left: 58px;
  content: "";
  width: 60px;
  height: 0px;
  /* border: 1px solid #000000; */
  opacity: 0.1;
}
.navCli {
  position: relative;
  width: 176px;
  height: 80px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 80px;
  color: #505050;
  opacity: 1;
  cursor: pointer;
}
.navCli::before {
  position: absolute;
  top: 80px;
  left: 58px;
  content: "";
  width: 60px;
  height: 0px;
  border: 1px solid #000000;
  opacity: 0.1;
}
.navCli:hover {
  color: #e7413b;
}
.navBom {
  position: absolute;
  top: 976px;
  width: 176px;
  height: 19px;
  background: url("../common/images/about/navBom.png") no-repeat;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/about.vue